import React from 'react'

export const Footer = () => {
  
  return (
      // it is used to make the footer we usually see in the website  
    <footer className="bg-dark text-light py-3" >
      <p  className="text-center">
          Copyright &copy; MyTodosList.com
      </p>
    </footer>
    
  )
}


//rafc is used here to crete this kinda syntax

